import { Provider } from '@angular/core';
import { GetSelectedCurrencyUseCase, SetSelectedCurrencyUseCase } from '@app/domain/use-cases';
import type { ISettingsRepository } from '@app/domain/ports';
import { SETTINGS_REPOSITORY } from '../../tokens/infrastructure.tokens';

/**
 * Provides Settings-related use cases.
 *
 * Includes:
 * - GetSelectedCurrencyUseCase: Retrieve user's selected currency preference
 * - SetSelectedCurrencyUseCase: Save user's selected currency preference
 *
 * All providers use constructor injection pattern following Clean Architecture.
 */
export function provideSettingsDomain(): Provider[] {
  return [
    // Use Cases
    {
      provide: GetSelectedCurrencyUseCase,
      useFactory: (settingsRepository: ISettingsRepository) => new GetSelectedCurrencyUseCase(settingsRepository),
      deps: [SETTINGS_REPOSITORY],
    },
    {
      provide: SetSelectedCurrencyUseCase,
      useFactory: (settingsRepository: ISettingsRepository) => new SetSelectedCurrencyUseCase(settingsRepository),
      deps: [SETTINGS_REPOSITORY],
    },
  ];
}
